export const CASE_STATUSES = [
  { value: "in_progress", label: "In Progress" },
  { value: "resolved", label: "Resolved" },
  { value: "escalated", label: "Escalated" },
];

export const caseStatusLabel = Object.fromEntries(CASE_STATUSES.map((s) => [s.value, s.label]));

export const sessionStatusLabel = {
  payment_pending: "Payment pending",
  scheduled: "Scheduled",
  in_progress: "In progress",
  completed: "Resolved",
  escalated: "Escalated",
  cancelled: "Cancelled",
};

export const sessionStatusStyle = {
  payment_pending: "bg-amber-100 text-amber-800 border-amber-300",
  scheduled: "bg-blue-100 text-blue-700 border-blue-300",
  in_progress: "bg-blue-600 text-white border-blue-700",
  completed: "bg-emerald-100 text-emerald-800 border-emerald-300",
  escalated: "bg-red-100 text-red-700 border-red-300",
  cancelled: "bg-slate-50 text-slate-500 border-slate-300",
};

export function caseStatusFromSession(s) {
  if (s.status === "completed") return "resolved";
  if (s.status === "escalated") return "escalated";
  return "in_progress";
}

const timeFmt = { hour: "numeric", minute: "2-digit" };

export function formatSlot(iso) {
  if (!iso) return { date: "—", slot: "—" };
  const start = new Date(iso);
  const end = new Date(start.getTime() + 2 * 60 * 60 * 1000);
  return {
    date: start.toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short", year: "numeric" }),
    slot: `${start.toLocaleTimeString("en-IN", timeFmt)} – ${end.toLocaleTimeString("en-IN", timeFmt)}`,
  };
}
